<template>
  <div class="success-chip" :class="bem('success-chip', { fullWidth })">
    <SvgIcon class="success-chip__icon" icon="check" color="muted" :size="24" />
    <b><slot /></b>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { bem } from 'src/utils/bem.js';

import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

export default defineComponent({
  name: 'SuccessChip',
  components: {
    SvgIcon,
  },
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      bem,
    };
  },
});
</script>
